import React from 'react';
import ImgHTML from '../ImgHTML';

const IndustriesSingleItem = ({ item }) => {
  return (
    <div className="col-md-6">
      <div className="single-item">
        <div className="icon">
          <ImgHTML src={item.icon} alt="enterprise icon" />
        </div>
        <div className="content">
          <h3 className="tt">{item.title}</h3>
          <div className="dd">{item.description}</div>
        </div>
      </div>
    </div>
  );
};

export default IndustriesSingleItem;
